module.exports = __webpack_public_path__ + "img/hezuo.69be3bf1.png";